module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p39"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rp39"
    }
  }, [_vm._v("CREAM OF CAULIFLOWER SOUP WITH CHEESE")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line-3.jpg",
      "width": "532"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "imagela"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "22",
      "src": "images/45.jpg",
      "width": "22"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('i', [_vm._v("Fat-free half-and-half adds a rich creaminess to the soup.")])])]), _vm._v(" "), _c('p', {
    staticClass: "make"
  }, [_c('span', [_vm._v("6 first-course servings")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("½ cup chopped onion")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 tablespoons flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("3½ cups reduced-sodium fat-free chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("12 ounces cauliflower, cut into florets")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 large Idaho potato, peeled, cubed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("¼–½ cup fat-free half-and-half or fat-free milk")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("¾ cup (3 ounces) reduced-fat Cheddar cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("Salt and white pepper, to taste")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("Ground mace or nutmeg, as garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('b', [_vm._v("1.")]), _vm._v(" Sauté onion and garlic in lightly greased large saucepan until tender, about 10 minutes; stir in flour and cook 1 minute. Add broth, cauliflower, and potato and heat to boiling; reduce heat and simmer, covered, until vegetables are tender, 10 to 15 minutes. Remove about half the vegetables from the soup with a slotted spoon and reserve. Purée remaining soup in food processor or blender until smooth; return to saucepan. Add reserved vegetables, half-and-half, and cheese; cook over low heat, stirring, until cheese is melted, 3 to 4 minutes. Season to taste with salt and white pepper; sprinkle each bowl of soup with mace.")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Per Serving:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Calories: 98")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("% calories from fat: 22")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Protein (g): 5.5")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Carbohydrate (g): 13.6")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat (g): 2.4")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Saturated fat (g): 1.1")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Cholesterol (mg): 7.6")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Sodium (mg): 214")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Exchanges:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Milk: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Vegetable: 1.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fruit: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Bread: 0.5")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Meat: 0.5")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("VARIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "normala",
    attrs: {
      "id": "p39a"
    }
  }, [_c('span', [_c('b', [_vm._v("Chilled Cauliflower Soup")]), _vm._v(" — Make soup as above, omitting Cheddar cheese and mace. Add 1 tablespoon dried dill weed to simmering "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("soup; process all the soup in food processor, without reserving any vegetables. Refrigerate until chilled; garnish each bowl of soup with chopped dill or parsley.")])]), _vm._v(" "), _c('p', {
    staticClass: "normala",
    attrs: {
      "id": "p39b"
    }
  }, [_c('span', [_c('b', [_vm._v("Fennel Bisque with Walnuts")]), _vm._v(" — Make soup as above, substituting 1 large leek, sliced, for the onion, and 2 large fennel bulbs, sliced, for the cauliflower. Complete soup as above, omitting Cheddar cheese. Ladle soup into bowls; sprinkle with 3 ounces crumbled blue cheese, and ¼ cup chopped toasted walnuts.")])]), _vm._v(" "), _c('p', {
    staticClass: "normala",
    attrs: {
      "id": "p39c"
    }
  }, [_c('span', [_c('b', [_vm._v("Cream of Turnip Soup")]), _vm._v(" — Make soup as above, substituting chopped turnips for the cauliflower and reduced-fat Swiss, Gouda, or Havarti cheese for the Cheddar; add ½ teaspoon dried thyme leaves.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f24728","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter0221.vue
// module id = 198
// module chunks = 0